import * as Edge from './Edges';

export const edgeTypes = {
  default: Edge.DefaultEdge,
  condition: Edge.ConditionEdge,
};
